export type SlotKey = "morning" | "afternoon";

export type AccessNeed = "wheelchair" | "elderly" | "stroller" | "allergy";

export interface BookingDraft {
  date: string;        // YYYY-MM-DD
  slot: SlotKey | null;
  headcount: number;
  needs: AccessNeed[];
  contactName: string;
  notes: string;
}

export interface BookingPayload extends BookingDraft {
  type: "ttyuansen.booking.tour.v1";
  slot: SlotKey;
  liffUserId?: string;
  liffDisplayName?: string;
  submittedAt: string; // ISO
}

export const SLOT_LABEL: Record<SlotKey, string> = {
  morning: "上午場 09:30 – 12:00",
  afternoon: "下午場 13:30 – 16:00",
};

export const NEED_LABEL: Record<AccessNeed, { label: string; sub: string }> = {
  wheelchair: { label: "輪椅同行", sub: "我們會安排平緩路線" },
  elderly: { label: "長輩同行", sub: "可建議休息點位置" },
  stroller: { label: "推嬰兒車", sub: "提醒可推路段" },
  allergy: { label: "有食物過敏", sub: "餐廳可預先告知" },
};
